import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\">\n    <path d=\"M18.2382 7.73828L16.6765 6.17651L7.94116 14.9118L16.6765 23.6471L18.2382 22.0853L11.0647 14.9118L18.2382 7.73828Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol